<template>
  <SSection :desktop-full="true" :title="t('views.cottage.location.title')">
    <div class="h-60 bg-gray-100 rounded-lg overflow-hidden">
      <CottageMap :item="item" />
    </div>
    <div class="mt-6">
      <TText variant="semibold" tag="span">
        {{ t('views.cottage.location.localization') }}
      </TText>
      <TText tag="span"
        >{{ item.address }} - {{ item.village.name }} ({{
          item.province.name
        }})</TText
      >
    </div>
    <div class="mt-6">
      <TText variant="semibold" tag="span">
        {{ t('views.cottage.location.coordinates.title') }}
      </TText>
      <TText tag="span">{{
        t('views.cottage.location.coordinates.text', {
          latitude: item.latitude,
          longitude: item.longitude,
        })
      }}</TText>
    </div>
    <div v-if="item.directions" class="mt-6" data-test="mapDirections">
      <TText variant="semibold" tag="span">
        {{ t('views.cottage.location.description') }}
      </TText>
      <TText tag="div" classes="mb-0">
        <div v-html="item.directions" />
      </TText>
    </div>
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = Pick<
  CottagePage,
  'latitude' | 'longitude' | 'address' | 'village' | 'province' | 'directions'
>

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
